<BolideLoader v-show="is_loading" />
<div class="dashboard-container container-fluid px-0" v-show="!is_loading">
    <div class="row g-0 vh-100 overflow-visible">
        <!-- ======= SIDEBAR AREA (DESKTOP ONLY) ======= -->
        <div v-if="!is_mobile" class="col-auto sidebar-wrapper sidebar-offset
                    d-flex flex-column flex-shrink-0
                    position-sticky
                    vh-100
                    overflow-hidden
                    overflow-x-visible" :class="{ 'sidebar-collapsed': sidebar_collapsed }">

            <PortfolioSidebar v-if="current_view === 'main'" :tiles="tiles" :active_item="active_menu_item" :collapsed="!is_mobile && sidebar_collapsed"
                @tile-clicked="handleTileClick" @global-menu-selected="handleGlobalMenuSelected"
                @property-menu-selected="handlePropertyMenuSelected" @global-selected="goBack" />

            <PropertySidebar v-else-if="selected_property" :active_property="selected_property" :properties="tiles" :collapsed="!is_mobile && sidebar_collapsed"
                @switch-property="handleTileClick" @go-back="goBack"
                @property-menu-selected="handlePropertyMenuSelected" />

        </div>
        <!-- ======= MOBILE SIDEBAR OVERLAY ======= -->
        <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="close_sidebar">
            <div class="mobile-sidebar-panel">

                <!-- ===== PORTFOLIO MODE ===== -->
                <PortfolioSidebar v-if="current_view === 'main'" :tiles="tiles" :active_item="active_menu_item" :collapsed="false"
                    @tile-clicked="handleTileClick" @global-menu-selected="handleGlobalMenuSelected"
                    @property-menu-selected="handlePropertyMenuSelected" @global-selected="goBack"
                    @close-sidebar="close_sidebar">
                    <!-- ❌ CLOSE BUTTON -->
                    <template #sidebar-header-actions>
                        <button class="sidebar-close-btn" @click="close_sidebar" aria-label="Close sidebar">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </template>
                </PortfolioSidebar>

                <!-- ===== PROPERTY MODE ===== -->
                <PropertySidebar v-else-if="selected_property" :active_property="selected_property" :properties="tiles" :collapsed="false"
                    @switch-property="handleTileClick" @go-back="goBack"
                    @property-menu-selected="handlePropertyMenuSelected" @close-sidebar="close_sidebar">
                    <!-- ❌ CLOSE BUTTON -->
                    <template #sidebar-header-actions>
                        <button class="sidebar-close-btn" @click="close_sidebar" aria-label="Close sidebar">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </template>
                </PropertySidebar>

            </div>
        </div>
        <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm btn-dark float-start" @click="toggleSidebar">
            <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
        </button>



        <!-- ======= MAIN CONTENT AREA ======= -->
        <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
            <!-- HEADER -->
            <HeaderSection :breadcrumb="breadcrumb" @breadcrumb-click="handleBreadcrumbClick"
                @open-assistant="show_assistant = true" @toggle-mobile-sidebar="toggle_mobile_sidebar" />

            <BolideAssistant :is_open="show_assistant" :tiles="tiles" :active-property="selected_property" :user="user"
                @close-assistant="show_assistant = false" />

            <main class="dashboard-main flex-grow-1 h-100">
                <!-- ================= MAIN VIEW (GLOBAL) ================= -->
                <div v-if="current_view === 'main'" class="dashboard-main-view h-100">
                    <div class="row g-0 h-100">

                        <PortfolioSuperSetChart :content_class="getMainContentClass()" chart_id="dashboard-main"
                            :iframe_loading="iframe_loading" />
                    </div>
                </div>

                <!-- ============== DETAIL VIEW ============== -->
                <div v-if="current_view !== 'main'" class="dashboard-detail-view">
                    <div class="card rounded-3 bg-transparent border">
                        <div class="portfolio-chart">
                            <div class="superset-embedded-container m-0 p-0">
                                <div :id="'dashboard-' + current_view"></div>
                                <div v-if="iframe_loading" class="iframe-loading">
                                    <div class="spinner-border spinner-border-sm me-2"></div>
                                    Loading embedded dashboard...
                                    <div v-if="iframe_error" class="error-message mt-2 text-danger">
                                        Failed to load dashboard. Please try refreshing.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 🤖 FLOATING ASSISTANT (MOBILE) -->
                <button v-if="is_mobile && !show_assistant" class="floating-assistant-btn btn btn-primary d-md-none"
                    @click="show_assistant = true" aria-label="Open assistant">
                    <i class="bi bi-robot floating-assistant-icon"></i>
                </button>

            </main>
        </div>

    </div>
</div>
